import { useEffect } from "react";

const SCROLL_AMOUNT = 100; // pixels per key press

export default function ArrowScroll() {
  useEffect(() => {
    const handleKeyDown = (e) => {
      const tag = document.activeElement?.tagName;
      const isTyping = tag === "INPUT" || tag === "TEXTAREA" || document.activeElement?.isContentEditable;

      if (isTyping) return;

      if (e.key === "ArrowDown") {
        e.preventDefault();
        window.scrollBy({ top: SCROLL_AMOUNT, behavior: "smooth" });
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        window.scrollBy({ top: -SCROLL_AMOUNT, behavior: "smooth" });
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return null;
}